const DEFAULT_BACKEND_URL = 'http://localhost:8080';

const hasProtocol = (value: string) => /^[a-z][a-z0-9+.-]*:\/\//i.test(value);

const normalizeBackendUrl = (value?: string) => {
  const raw = (value || '').trim();
  if (!raw) {
    return DEFAULT_BACKEND_URL;
  }

  const withProtocol = hasProtocol(raw) ? raw : `https://${raw}`;
  return withProtocol.replace(/\/+$/, '');
};

export const BACKEND_URL = normalizeBackendUrl(process.env.REACT_APP_BACKEND_URL);
export const WS_BACKEND_URL = BACKEND_URL.replace(/^http/i, 'ws');
